import { useAppSelector } from 'flow/hooks/useRedux';
import { TicketKey } from 'flow/types/EntityKeys';
import { ConversationMessageKey } from 'flow/types/TicketEventData';
import {
    selectEmailMessageCcRecipients,
    selectEmailMessageToRecipients,
} from 'flow/selectors/TicketEventSelectors';
import { Menu, MenuButton } from '@headlessui/react';
import Icon from 'flow/components/ui-components/Icon';
import MenuSenderAndRecipients from './MenuSenderAndRecipients';

interface Props {
    ticketKey: TicketKey;
    eventKey: ConversationMessageKey;
}

const ButtonShowSenderAndRecipients = ({ ticketKey, eventKey }: Props) => {
    const hasToRecipientsData = useAppSelector(
        (state) => !!selectEmailMessageToRecipients(state, ticketKey, eventKey),
    );
    const hasCcRecipientsData = useAppSelector(
        (state) => !!selectEmailMessageCcRecipients(state, ticketKey, eventKey),
    );

    if (!hasToRecipientsData && !hasCcRecipientsData) return null;

    return (
        <Menu as="div" className="relative">
            <MenuButton
                className="flex items-center justify-center rounded pt-0.5 hover:bg-gray-300"
                aria-label="Show sender and recipients"
            >
                <Icon iconKey="arrow_down" size="1rem" />
            </MenuButton>
            <MenuSenderAndRecipients
                ticketKey={ticketKey}
                eventKey={eventKey}
            />
        </Menu>
    );
};

export default ButtonShowSenderAndRecipients;
